import { FC } from 'react';

import { ESHOP_TEST_ID } from '../../test/test-ids';
import { IncrementInputContainer, NumberInput, NumberInputPostfixSign } from './IncrementInput.styles';
import { IncrementInputProps } from './model';
import { RoundButton } from './RoundButton';
import { useIncrementInputControls } from './useIncrementInputControls';

export const IncrementInput: FC<IncrementInputProps> = ({
    minValue = 0,
    maxValue = 100,
    paymentInCart,
    incrementStep = 10,
    onChange,
    ariaLabelledBy,
}) => {
    const { inputValue, handleOutsideClick, handleDecrementClick, handleIncrementClick, handleInputChange } =
        useIncrementInputControls({ minValue, maxValue, paymentInCart, onChange, incrementStep });

    return (
        <IncrementInputContainer role="group" aria-labelledby={ariaLabelledBy}>
            <RoundButton
                dataTest={ESHOP_TEST_ID.INCREMENT_INPUT_DECREMENT_BTN}
                onClick={handleDecrementClick}
                disabled={inputValue <= minValue}
                iconVariant="minus"
                ariaLabel="mažinti įmoka"
            />

            <NumberInput
                type="number"
                inputMode="numeric"
                autoComplete="off"
                step={incrementStep}
                min={minValue}
                max={maxValue}
                value={String(inputValue)}
                onChange={handleInputChange}
                onBlur={handleOutsideClick}
                afterField={<NumberInputPostfixSign>&euro;</NumberInputPostfixSign>}
                data-test={ESHOP_TEST_ID.INCREMENT_INPUT}
                aria-label="įvesti įmoka"
            />

            <RoundButton
                dataTest={ESHOP_TEST_ID.INCREMENT_INPUT_INCREMENT_BTN}
                onClick={handleIncrementClick}
                disabled={inputValue >= maxValue}
                iconVariant="plus"
                ariaLabel="didinti įmoka"
            />
        </IncrementInputContainer>
    );
};
